/**
 * AI Recruit - Reports API Service
 * Organization-level report downloads (gated on reports.viewDownload).
 */

import { apiV2 } from './api'

const filenameFrom = (disposition: string | undefined, fallback: string): string => {
  const match = disposition?.match(/filename="?([^";]+)"?/i)
  return match ? match[1] : fallback
}

export const downloadUsageHiringReport = async (): Promise<void> => {
  const response = await apiV2.get('/reports/usage-hiring/download', {
    responseType: 'blob',
    timeout: 120000,
  })
  const url = window.URL.createObjectURL(response.data)
  const a = document.createElement('a')
  a.href = url
  a.download = filenameFrom(
    response.headers?.['content-disposition'],
    `AIRecruit_Usage_Hiring_Report_${new Date().toISOString().slice(0, 10)}.xlsx`,
  )
  document.body.appendChild(a)
  a.click()
  a.remove()
  window.URL.revokeObjectURL(url)
}
